import { Outlet } from "react-router-dom";

export function AppRoot() {
  return <Outlet />;
}
